const routes = [{
		path: '/',
		redirect: "/login",
	},

	// 以下是管理后台------------------------
	{
		path: '/login',
		name: 'login',
		component: () =>
			import('@/views/login/login.vue')
	},
	{
		path: '/wxLogin',
		name: 'wxLogin',
		component: () =>
			import('../views/login/wxLogin.vue')
	},
	{
		path: '/wxLoginS',
		name: 'wxLoginS',
		component: () =>
			import('../views/login/wxLoginSuccess.vue')
	},
	{
		path: '/wxbdPage',
		name: 'wxbdPage',
		component: () =>
			import('../views/login/wxbdPage.vue')
	},
	{
		path: '/wxbdV2',
		name: 'wxbdV2',
		component: () =>
			import('../views/login/wxbdV2.vue')
	},
	{
		path: '/wxjbV2',
		name: 'wxjbV2',
		component: () =>
			import('../views/login/wxjbV2.vue')
	},
	{
		path: '/gzhOpenid',
		name: 'gzhOpenid',
		component: () =>
			import('../views/login/gzhOpenid.vue')
	},
	{
		path: '/wxjbPage',
		name: 'wxjbPage',
		component: () =>
			import('../views/login/wxjbPage.vue')
	},
	{
		path: '/download',
		name: 'download',
		component: () =>
			import('../views/login/download.vue')
	},
	{
		path: '/vehicleMap',
		name: 'vehicleMap',
		component: () =>
			import('../views/vehicleMap/index.vue')
	},
	{
		path: '/vehicleMapTrack',
		name: 'vehicleMapTrack',
		component: () =>
			import('../views/vehicleMapTrack/index.vue')
	},
	{
		path: '/orderTrack',
		name: 'orderTrack',
		component: () =>
			import('../views/vehicleMapTrack/orderTrack.vue')
	},
	{
		path: '/layout',
		name: 'layout',
		component: () => import('@/views/layout/index.vue'),
		children: [{
				path: '/index',
				name: 'adminIndex',
				component: () => import('@/views/index/index.vue'),
				meta: {
					login: true
				}
			},
			{
				path: '/menuManagemen',
				name: 'menuManagemen',
				component: () => import('@/views/menuManagemen/index.vue'),
				meta: {
					login: true
				}
			},
			{
				path: '/menuManagemenApp',
				name: 'menuManagemenApp',
				component: () => import('@/views/menuManagemenApp/index.vue'),
				meta: {
					login: true
				}
			},
			{
				path: '/roleManagement',
				name: 'roleManagement',
				component: () => import('@/views/roleManagement/index.vue'),
				meta: {
					login: true
				}
			},
			{
				path: '/userManage',
				name: 'userManage',
				component: () => import('@/views/userManage/index.vue'),
				meta: {
					login: true
				}
			},
			{
				path: '/orgManage',
				name: 'orgManage',
				component: () => import('@/views/orgManage/index.vue'),
				meta: {
					login: true
				}
			},
			{
				path: '/customerManage',
				name: 'customerManage',
				component: () => import('@/views/customerManage/index.vue'),
				meta: {
					login: true
				}
			},
			{
				path: '/lineManage',
				name: 'lineManage',
				component: () => import('@/views/lineManage/index.vue'),
				meta: {
					login: true
				}
			},
			{
				path: '/siteManage',
				name: 'siteManage',
				component: () => import('@/views/siteManage/index.vue'),
				meta: {
					login: true
				}
			},
			{
				path: '/parkingManage',
				name: 'parkingManage',
				component: () => import('@/views/parkingManage/index.vue'),
				meta: {
					login: true
				}
			},
			{
				path: '/vehicleManage',
				name: 'vehicleManage',
				component: () => import('@/views/vehicleManage/index.vue'),
				meta: {
					login: true
				}
			},
			// {
			//     path: '/vehicleMap',
			//     name: 'vehicleMap',
			//     component: () => import('@/views/vehicleMap/index.vue'),
			//     meta: {
			//         login: true
			//     }
			// },
			{
				path: '/tractionVehicle',
				name: 'tractionVehicle',
				component: () => import('@/views/tractionVehicle/index.vue'),
				meta: {
					login: true
				}
			},
			{
				path: '/trailerVehicles',
				name: 'trailerVehicles',
				component: () => import('@/views/trailerVehicles/index.vue'),
				meta: {
					login: true
				}
			},
			{
				path: '/driverManage',
				name: 'driverManage',
				component: () => import('@/views/driverManage/index.vue'),
				meta: {
					login: true
				}
			},
			{
				path: '/escortManage',
				name: 'escortManage',
				component: () => import('@/views/escortManage/index.vue'),
				meta: {
					login: true
				}
			},
			{
				path: '/waybillPlan',
				name: 'waybillPlan',
				component: () => import('@/views/waybillPlan/index.vue'),
				meta: {
					login: true
				}
			},
			{
				path: '/waybillManage',
				name: 'waybillManage',
				component: () => import('@/views/waybillManage/index.vue'),
				meta: {
					login: true
				}
			},
			{
				path: '/waybillReport',
				name: 'waybillReport',
				component: () => import('@/views/waybillReport/index.vue'),
				meta: {
					login: true
				}
			},
			{
				path: '/systemLogManage',
				name: 'systemLogManage',
				component: () => import('@/views/systemLogManage/index.vue'),
				meta: {
					login: true
				}
			},
			{
				path: '/versionManage',
				name: 'versionManage',
				component: () => import('@/views/versionManage/index.vue'),
				meta: {
					login: true
				}
			},
			{
				path: '/shenpiManage',
				name: 'shenpiManage',
				component: () => import('@/views/shenpiManage/index.vue'),
				meta: {
					login: true
				}
			},
			{
				path: '/messageManage',
				name: 'messageManage',
				component: () => import('@/views/messageManage/index.vue'),
				meta: {
					login: true
				}
			},
			{
				path: '/costManage',
				name: 'costManage',
				component: () => import('@/views/costManage/index.vue'),
				meta: {
					login: true
				}
			},
			{
				path: '/ledgerManage',
				name: 'ledgerManage',
				component: () => import('@/views/ledgerManage/index.vue'),
				meta: {
					login: true
				}
			},
			{
				path: '/vehLedgerManage',
				name: 'vehLedgerManage',
				component: () => import('@/views/vehLedgerManage/index.vue'),
				meta: {
					login: true
				}
			},
			{
				path: '/maintenance',
				name: 'maintenance',
				component: () => import('@/views/maintenance/index.vue'),
				meta: {
					login: true
				}
			},
			{
				path: '/insurance',
				name: 'insurance',
				component: () => import('@/views/insurance/index.vue'),
				meta: {
					login: true
				}
			},
			{
				path: '/repair',
				name: 'repair',
				component: () => import('@/views/repair/index.vue'),
				meta: {
					login: true
				}
			},
			{
				path: '/tire',
				name: 'tire',
				component: () => import('@/views/tire/index.vue'),
				meta: {
					login: true
				}
			},
			{
				path: '/inspection',
				name: 'inspection',
				component: () => import('@/views/inspection/index.vue'),
				meta: {
					login: true
				}
			},
			{
				path: '/violation',
				name: 'violation',
				component: () => import('@/views/violation/index.vue'),
				meta: {
					login: true
				}
			},
			{
				path: '/accident',
				name: 'accident',
				component: () => import('@/views/accident/index.vue'),
				meta: {
					login: true
				}
			},
			{
				path: '/payment',
				name: 'payment',
				component: () => import('@/views/payment/index.vue'),
				meta: {
					login: true
				}
			},
			{
				path: '/receipt',
				name: 'receipt',
				component: () => import('@/views/receipt/index.vue'),
				meta: {
					login: true
				}
			},
			{
				path: '/reconciliation',
				name: 'reconciliation',
				component: () => import('@/views/reconciliation/index.vue'),
				meta: {
					login: true
				}
			},
			{
				path: '/warehousePro',
				name: 'warehousePro',
				component: () => import('@/views/warehousePro/index.vue'),
				meta: {
					login: true
				}
			},
			{
				path: '/warehouseIn',
				name: 'warehouseIn',
				component: () => import('@/views/warehouseIn/index.vue'),
				meta: {
					login: true
				}
			},
			{
				path: '/warehouseOut',
				name: 'warehouseOut',
				component: () => import('@/views/warehouseOut/index.vue'),
				meta: {
					login: true
				}
			},
			{
				path: '/xyList',
				name: 'xyList',
				component: () => import('@/views/xyList/index.vue'),
				meta: {
					login: true
				}
			},

		],
	},

]
export default routes;